export const endPoints = {
    // Auth
    login: '/auth/login',
    signup: '/auth/signup',
    profile: '/auth/getUserProfile',
    updateProfile: '/auth/updateUserProfile',

    // Modules
    modules: {
        getAll: '/modules/getAllModulesAdmin', // Use admin endpoint to get program details
        getById: (id: string) => `/modules/getModuleById/${id}`,
        create: '/modules/createModule',
        update: (id: string) => `/modules/updateModule/${id}`,
        delete: (id: string) => `/modules/deleteModule/${id}`,
        uploadVideo: (id: string) => `/modules/uploadModuleVideo/${id}`,
    },

    // Programs
    programs: {
        getAll: '/programs/getAllPrograms',
        getById: (id: string) => `/programs/getProgramById/${id}`,
        // Note: Admin CRUD endpoints may need to be added to backend
        create: '/programs/createProgram',
        update: (id: string) => `/programs/updateProgram/${id}`,
        delete: (id: string) => `/programs/deleteProgram/${id}`,
    },

    // Resources
    resources: {
        getAll: '/resources/getAllResources',
        getById: (id: string) => `/resources/getResourceById/${id}`,
        // Note: Admin CRUD endpoints may need to be added to backend
        create: '/resources/createResource',
        update: (id: string) => `/resources/updateResource/${id}`,
        delete: (id: string) => `/resources/deleteResource/${id}`,
    },

    // Micro Practices
    microPractices: {
        getAll: '/micro-practices/getAllMicroPractices',
        getById: (id: string) => `/micro-practices/getMicroPracticeById/${id}`,
        // Note: Admin CRUD endpoints may need to be added to backend
        create: '/micro-practices/createMicroPractice',
        update: (id: string) => `/micro-practices/updateMicroPractice/${id}`,
        delete: (id: string) => `/micro-practices/deleteMicroPractice/${id}`,
    },

    // Playlists
    playlists: {
        getAll: '/playlists/getPlaylists',
        getById: (id: string) => `/playlists/getPlaylistById/${id}`,
        create: '/playlists/createPlaylist',
        update: (id: string) => `/playlists/updatePlaylist/${id}`,
        delete: (id: string) => `/playlists/deletePlaylist/${id}`,
    },

    // Users
    users: {
        getAll: '/users/getAllUsers',
        getById: (id: string) => `/users/getUserById/${id}`,
        create: '/users/createUser',
        update: (id: string) => `/users/updateUser/${id}`,
        delete: (id: string) => `/users/deleteUser/${id}`,
    },

    // Settings
    settings: {
        get: '/settings',
        update: '/settings',
    },

    // Program Categories
    programCategories: {
        getAll: '/program-categories/getAllProgramCategories',
        getById: (id: string) => `/program-categories/getProgramCategoryById/${id}`,
        create: '/program-categories/createProgramCategory',
        update: (id: string) => `/program-categories/updateProgramCategory/${id}`,
        delete: (id: string) => `/program-categories/deleteProgramCategory/${id}`,
    },

    // Resource Categories
    resourceCategories: {
        getAll: '/resource-categories/getAllResourceCategories',
        getById: (id: string) => `/resource-categories/getResourceCategoryById/${id}`,
        create: '/resource-categories/createResourceCategory',
        update: (id: string) => `/resource-categories/updateResourceCategory/${id}`,
        delete: (id: string) => `/resource-categories/deleteResourceCategory/${id}`,
    },

    // Dashboard
    dashboard: {
        subscriptionAnalytics: '/dashboard/subscription-analytics',
        checkinAnalytics: '/dashboard/checkin-analytics',
        journalAnalytics: '/dashboard/journal-analytics',
        playlistAnalytics: '/dashboard/playlist-analytics',
        overviewCounts: '/dashboard/overview-counts',
    },

    // Subscriptions
    subscriptions: {
        getStatus: '/subscriptions/status',
        getPlans: '/subscriptions/plans',
        getTransactions: '/subscriptions/transactions',
        create: '/subscriptions/create',
        cancel: '/subscriptions/cancel',
        stripeConfig: '/subscriptions/stripe-config',
    },

    // Check-In Questions
    checkInQuestions: {
        getAll: '/check-in-questions',
        create: '/check-in-questions',
        update: (id: string) => `/check-in-questions/${id}`,
        delete: (id: string) => `/check-in-questions/${id}`,
    },

    // Program User Progress
    programUserProgress: {
        getAll: '/program-user-progress/getProgramUserProgress',
        update: (id: string) => `/program-user-progress/updateProgramUserProgress/${id}`,
        startProgram: (id: string) => `/program-user-progress/startProgram/${id}`,
        completeProgram: (id: string) => `/program-user-progress/completeProgram/${id}`,
    },

    // Roles
    roles: {
        getAll: '/roles',
        getById: (id: string) => `/roles/${id}`,
        create: '/roles',
        update: (id: string) => `/roles/${id}`,
        delete: (id: string) => `/roles/${id}`,
        assign: '/roles/assign',
        remove: (userId: string) => `/roles/remove/${userId}`,
        getUsersByRole: (id: string) => `/roles/${id}/users`,
    },

    // Permissions
    permissions: {
        getAll: '/permissions',
        getById: (id: string) => `/permissions/${id}`,
        getByResource: (resource: string) => `/permissions/resource/${resource}`,
        create: '/permissions',
        update: (id: string) => `/permissions/${id}`,
        delete: (id: string) => `/permissions/${id}`,
    },

    // Journal
    journal: {
        getAll: '/journal/getJournalEntries',
        getById: (id: string) => `/journal/getJournalEntry/${id}`,
        create: '/journal/createJournalEntry',
        update: (id: string) => `/journal/updateJournalEntry/${id}`,
        delete: (id: string) => `/journal/deleteJournalEntry/${id}`,
    },

    // Daily Check-In
    dailyCheckIn: {
        createOrUpdate: '/daily-checkin/createOrUpdateDailyCheckIn',
        getAll: '/daily-checkin/getAllCheckIns',
    },
};

